/**
 * Panoda "bana düşen işler" (ADR 0156): Active Alerts panelinin iş bölümü, zil listesi ve
 * dar ekranda panele atlama bağlantısı.
 */
export const tasksEn = {
  badge: '{{count}} awaiting you',
  overdueBadge: '{{count}} overdue',
  heading: 'Awaiting your action',
  alertsHeading: 'Alerts',
  more: '+{{count}} more',
  viewAll: 'View all',
  upcoming: '{{count}} upcoming',
  none: 'Nothing is waiting for you.',
  error: 'Your tasks could not be loaded.',
  retry: 'Try again',
  partial: 'Some tasks could not be loaded; the list may be incomplete.',
  refresh: 'Refresh',
  loading: 'Loading your tasks',
  jump: '{{count}} awaiting you – go to Active Alerts',
  step: 'Step {{step}}',
  badges: {
    overdue: 'Overdue',
    escalated: 'Escalated',
    returned: 'Returned',
  },
  kind: {
    returned: 'Returned to you',
    ctm_decision: 'Cash to Master approval',
    ctm_transfer: 'Arrange CTM payment',
    cash_review: 'Cash count review',
    requisition_decision: 'Requisition approval',
    requisition_processing: 'Requisitions to process',
    po_decision: 'Purchase order approval',
    invoice_review: 'Invoice review',
    payment_approval: 'Payment approval',
    supplier_bank_review: 'Supplier bank change',
    pms_decision: 'PMS approval',
    fuel_adjustment_decision: 'Fuel ROB adjustment',
    certificate_issuance: 'Certificates issued on board',
    hse_decision: 'HSE report approval',
    risk_decision: 'Risk assessment approval',
    document_revision: 'Document revision',
    ism_form_decision: 'ISM form approval',
  },
  variant: {
    interval_change: 'Interval change',
    defect: 'Defect',
    breakdown: 'Breakdown',
    work_record: 'Work record',
    postponement: 'Postponement',
    approve: 'Approve',
    publish: 'Publish',
    review: 'Review',
    rfq: 'RFQ',
  },
  // Pano başlığında kişinin rolleri (04.11 notları C3)
  roles_one: 'Your role: {{roles}}',
  roles_other: 'Your roles: {{roles}}',
};

export const tasksTr: typeof tasksEn = {
  badge: '{{count}} iş sizi bekliyor',
  overdueBadge: '{{count}} gecikmiş',
  heading: 'Sizi bekleyen işler',
  alertsHeading: 'Uyarılar',
  more: '+{{count}} daha',
  viewAll: 'Tümünü gör',
  upcoming: '{{count}} sırada',
  none: 'Sizi bekleyen iş yok.',
  error: 'İşleriniz okunamadı.',
  retry: 'Yeniden dene',
  partial: 'Bazı işler okunamadı; liste eksik olabilir.',
  refresh: 'Yenile',
  loading: 'İşleriniz yükleniyor',
  jump: "{{count}} iş sizi bekliyor – Aktif Uyarılar'a git",
  step: '{{step}}. adım',
  badges: {
    overdue: 'Gecikti',
    escalated: 'Yükseltildi',
    returned: 'İade edildi',
  },
  kind: {
    returned: 'Size iade edilenler',
    ctm_decision: 'CTM onayı',
    ctm_transfer: 'CTM ödemesi',
    cash_review: 'Kasa sayımı incelemesi',
    requisition_decision: 'Malzeme talebi onayı',
    requisition_processing: 'İşlenecek talepler',
    po_decision: 'Sipariş onayı',
    invoice_review: 'Fatura incelemesi',
    payment_approval: 'Ödeme onayı',
    supplier_bank_review: 'Tedarikçi banka değişikliği',
    pms_decision: 'PMS onayı',
    fuel_adjustment_decision: 'Yakıt ROB düzeltmesi',
    certificate_issuance: 'Gemide düzenlenen sertifikalar',
    hse_decision: 'HSE raporu onayı',
    risk_decision: 'Risk değerlendirmesi onayı',
    document_revision: 'Doküman revizyonu',
    ism_form_decision: 'ISM form onayı',
  },
  variant: {
    interval_change: 'Bakım aralığı değişikliği',
    defect: 'Arıza',
    breakdown: 'Hasar',
    work_record: 'İş kaydı',
    postponement: 'Erteleme',
    approve: 'Onay',
    publish: 'Yayın',
    review: 'İnceleme',
    rfq: 'RFQ',
  },
  // Pano başlığında kişinin rolleri (04.11 notları C3)
  roles_one: 'Rolünüz: {{roles}}',
  roles_other: 'Rolleriniz: {{roles}}',
};
